


/*Precondicion: solo un video en la carpeta*/

//const AllTransitions = () => { return ImportHelper.importAll(require.context("../assets/videos/", true, /\.mp4/)); }

export const ContextTransitions = {
    "General View": { initFrame:  80 },
    "Torre 1": { initFrame:  0 },
    "Torre 2": { initFrame:  0 },

    "Acceso vehicular": { initFrame:  0 },
    "Locales comerciales": { initFrame:  40 },
    "Zona de mascotas": { initFrame:  70 },
    "Parque infantil": { initFrame:  120 },
    "Placa polideportiva": { initFrame:  45 },
    "Salón social": { initFrame:  10 },
    "Gym": { initFrame:  25 },
    "Piscina": { initFrame:  122 },
    "Gimnasio al aire libre": { initFrame:  70 },
    "BBQ": { initFrame:  90 },
    "Yoga": { initFrame:  90 },

    //"EveryTransition": { importTransition: AllTransitions }
}
